import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";
import { ArrowLeft } from "lucide-react";
import { PublicFooter } from "@/components/PublicFooter";

export default function About() {
  return (
    <>
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="max-w-lg w-full">
        <BrandLogo />
        <h1 className="font-display font-extrabold text-4xl text-ink mt-8 mb-4">À propos de Pulse</h1>
        <p className="text-ink-light leading-relaxed mb-4">
          Pulse est un studio éditorial multicanal : il vous aide à rédiger des posts de haute qualité dans votre voix,
          à créer des visuels à votre image, puis à planifier et publier automatiquement sur votre profil LinkedIn.
        </p>
        <p className="text-ink-light leading-relaxed mb-4">
          Le même message est ensuite décliné pour Facebook, Instagram, X et Substack, dans les codes de chaque
          plateforme, avec le même visuel. Vous gardez la main sur la publication.
        </p>
        <p className="text-ink-light leading-relaxed mb-8">
          La différenciation de Pulse, c'est la <span className="font-semibold text-ink">qualité éditoriale</span>, jamais le volume ni le contenu générique.
        </p>
        <div className="border-t border-border pt-6 flex items-center justify-between">
          <p className="text-sm text-ink-light/70">Pulse, <span className="font-semibold text-ink">by APOLLO</span></p>
          <Link to="/login" data-testid="about-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-coral-dark hover:text-coral transition-colors">
            <ArrowLeft className="h-4 w-4" /> Retour
          </Link>
        </div>
      </div>
    </div>
    <PublicFooter />
    </>
  );
}
